

import React from 'react';
import { connect } from 'react-redux';
import { Button, Input, Tooltip } from 'reactstrap';
import { FaArrowRight, FaArrowLeft } from 'react-icons/fa';
// import ApuaWhiteTextLogo from '../../ImageAssets/ApuaWhiteTextLogo.png';
import ApuaWhiteTextLogo from '../../ImageAssets/Apua_New_Logo.png';
import { setLoginPage, setUserRegisterDetails } from '../../General/Actions';
import Background from '../../ImageAssets/blueskyBackground.png';
import Network from '../../Utils/network.js';
import ValidateForm from '../../Utils/formValidation';
import Swal from 'sweetalert2';
import LoadingAnimation from '../../Utils/loadingAnimation.js';
import infoIcon from '../../ImageAssets/infoIcon.png';

class RegisterCredentialsComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false
        }
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions = () => {
        this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
    }

    inputValueChange(name, value) {
        this.setState({ [name]: value })
    }

    submitBtnClicked() {
        if (ValidateForm.inputFieldMandatoryCheck("registerCredentialsContainer", this.props.locales, false)) {
            if (ValidateForm.inputFieldValueCompositionCheck("registerCredentialsContainer", this.props.locales, false)) {
                this.setState({ isLoading: true })
                Network.executeAxios("duplicateUsernameCheck", "POST", { "username": this.state.username }, (duplicateUsernameCheckResponse) => {
                    if (duplicateUsernameCheckResponse.STATUS === "USER_ALREADY_EXIST") {
                        this.setState({ isLoading: false })
                        // Toast.showToast("Duplicate Username Found");
                        Swal.fire(this.props.locales.duplicateUsernameInSwal, "", "");
                    } else {
                        if(this.state.password === this.state.confirmPassword){
                            this.props.setUserRegisterDetails("username", this.state.username);
                            this.props.setUserRegisterDetails("password", this.state.password);
                            setTimeout(() => {
                                this.finalRegister()
                            }, 100);
                        } else {
                            this.setState({isLoading: false})
                            Swal.fire(this.props.locales.SettingsCompPswDoNtMatchSwal, "", "");
                        }
                    }
                });
            }
        }
    }

    finalRegister() {
        setTimeout(() => {


            Network.executeAxios("querySubscriberForParticularProfile", "POST", { "profileId": this.props.userRegisterDetails.customerId }, (receivedResponse) => {
                var params = [];
                try {
                    params = receivedResponse.profile_info.basic_details;
                } catch (err) {
                    params = [];
                }
                var customerCategory = "";
                var customerSubCategory = "";
                for (var i = 0; i < params.length; i++) {
                    if (params[i].id === "subscriber_category") {
                        customerCategory = params[i].value;
                    }
                    if (params[i].id === "subscriber_sub_category") {
                        customerSubCategory = params[i].value;
                    }
                }
                var categoryToSend = {
                    customerCategory: customerCategory,
                    customerSubCategory: customerSubCategory
                }
                Network.executeAxios("getRoleName", "POST", categoryToSend, (roleResponse) => {
                    var dataToSend = {
                        "source":"WEB",
                        "roleId": roleResponse.roleId,
                        "roleName": roleResponse.roleName,
                        "name": this.props.userRegisterDetails.username,
                        "profileId": this.props.userRegisterDetails.customerId,
                        "pin": this.props.userRegisterDetails.pinNumber,
                        "connectionType":this.props.userRegisterDetails.connectionType,
                        "password": this.props.userRegisterDetails.password,
                        "phoneNumber": this.props.userRegisterDetails.profileContactNumber,
                        "email": this.props.userRegisterDetails.email,
                        "question1": this.state.question1,
                        "question2": this.state.question2,
                        "question3": this.state.question3,
                        "answer1": this.state.answer1,
                        "answer2": this.state.answer2,
                        "answer3": this.state.answer3
                    };
                    Network.executeAxios("finalUserRegister", "POST", dataToSend, (response) => {
                        this.setState({ isLoading: false })
                        if (response.STATUS === "SUCCESS") {
                            Swal.fire(this.props.locales.RegisterQuestionsRegSuccessSwal);
                            window.location.reload();
                        } else if (response.STATUS === "USER_ALREADY_EXIST") {
                            Swal.fire(this.props.locales.RegisterQuestionsUserAlredyExistSwal);
                            window.location.reload();
                        } else {
                            Swal.fire(this.props.locales.RegisterQuestionsRegFailedSwal);
                            window.location.reload();
                        }
                    });
                });
            });
        }, 100);

    }

    render() {
        return (
            <div>
                <div id="toastPopup" className="animated slideInRight d-none"></div>
                {this.state.isLoading ? <LoadingAnimation isVisible={true} /> : null}
                {this.componentContent()}
            </div>
        );
    }

    componentContent() {
        const registerCredentialsOuterMainContainerStyle = { height: (this.state.windowHeight) + 'px', display: "flex", flexDirection: "column", justifyContent: "space-between" };
        return (
            <div style={registerCredentialsOuterMainContainerStyle}>
                <div className="row m-0" style={{ flex: 1 }}>
                    <div className="col-md-6 p-0 d-none d-sm-block" >
                        <div className="leftPartBackgroundImage" style={{ display: "flex", flexDirection: "column", height: "100%", flex: 1, alignItems: "center", justifyContent: "center", background: `url(${Background}) 20%`, backgroundSize: 'cover' }}>
                            {this.loginPartComponent()}
                        </div>
                    </div>
                    <div className="col-md-6 p-0" >
                        <div style={{ display: "flex", height: "100%", flex: 1, justifyContent: "center", backgroundColor: '#ffffff' }}>
                            {this.registerCredentialsComponent()}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    registerCredentialsComponent() {
        return (
            <div className="loginPageLeftPart col-md-12 row p-0 m-0">
                <div className="d-none d-sm-block d-md-none d-block col-md-12 p-0">
                    <div className="row col-md-12 m-auto py-2 px-2" style={{ backgroundColor: '#0285CA' }}>
                        <div className="col-md-12"><FaArrowLeft color="#fafafa" size="16" onClick={() => this.loginButtonClicked()} /> <img alt="" src={ApuaWhiteTextLogo} height="60" /></div>
                    </div>
                </div>
                <div className="col-md-12 row m-0 my-5 d-none d-sm-block">

                </div>

                <div className="col-md-12 row m-0">
                    <div className="col-md-1"></div>
                    <div className="col-md-10 pl-sm-5 pl-2 pt-0" id="registerCredentialsContainer">
                        <div className="col-md-12" style={{ fontSize: 18, color: '#404042' }}>{this.props.locales.registerCredentialAccountSignUpTxt}</div>
                        <div className="col-md-12" style={{ fontSize: 18, color: '#404042', fontWeight: 500 }}>{this.props.locales.registerCredentialStepTxt}</div>
                        <div className="col-md-12" style={{ fontSize: 28, color: '#404042', fontWeight: 300 }}>{this.props.locales.registerCredentialChooseUserNamePswTxt}</div>
                        <div className="col-md-12" style={{ fontSize: 16, color: '#404042', fontWeight: 300 }}>{this.props.locales.registerCredentialSafeAndSecureTxt}</div>
                        <div className="form-group col-md-11 pb-2 pt-4" >
                            <label className="d-none animated slideInUp m-0" style={{ color: '#a3b4bc', fontSize: 12, position: 'absolute' }}>{this.props.locales.registerCredentialuserNameTxt}</label>
                            <Input type="text" name="username" autoComplete="new-password" style={{ color: '#404042', fontWeight: 500 }}
                                className="loginCredItem input_data mandatoryFieldSpecial typeName pt-4 pb-3" placeholder={this.props.locales.registerCredentialChooseUsrNamePlc}
                                onChange={(event) => this.inputValueChange("username", event.target.value)}
                                onKeyUp={(event) => this.displayLabel(event, this.state.username, this.props.locales.registerCredentialChooseUsrNamePlc)} />
                            <div className="errorDesc" style={{ color: 'red', fontSize: 12, fontWeight: 400, position: 'absolute' }}></div>
                        </div>
                        <div className="form-group col-md-11 pb-2" >
                            <label className="d-none animated slideInUp m-0" style={{ color: '#a3b4bc', fontSize: 12, position: 'absolute' }}>{this.props.locales.registerCredentialPasswordTxt}
                            {/* <span style={{ paddingLeft: 5, cursor: 'pointer' }}>
                                    <button className="tooltipContainer" id="passwordInfoTooltip"><img src={infoIcon} alt="" /></button>
                                </span>

                                <Tooltip placement="top" isOpen={this.state.isPasswordInfoTooltipOpen} target="passwordInfoTooltip" toggle={() => { this.setState({ isPasswordInfoTooltipOpen: !this.state.isPasswordInfoTooltipOpen }) }}>
                                    {this.props.locales.SettingsCompCharecterToolTip}
                                </Tooltip> */}
                            </label>
                            <Input type="password" name="password" autoComplete="new-password" style={{ color: '#404042', fontWeight: 500 }}
                                className="loginCredItem input_data mandatoryFieldSpecial typePassword pt-4 pb-3" placeholder={this.props.locales.registerCredentialEnterPasswordPlc}
                                onChange={(event) => this.inputValueChange("password", event.target.value)}
                                onKeyUp={(event) => this.displayLabel(event, this.state.password, this.props.locales.registerCredentialEnterPasswordPlc)} />
                            <div className="errorDesc" style={{ color: 'red', fontSize: 12, fontWeight: 400 }}></div>
                            <div className="errorDescription" style={{ color: 'red', fontSize: 12, fontWeight: 400 }}></div>
                        </div>
                        <div className="form-group col-md-11" >
                            <label className="d-none animated slideInUp m-0" style={{ color: '#a3b4bc', fontSize: 12, position: 'absolute' }}>{this.props.locales.SettingsCompReTypePswLabel}</label>
                            <Input type="password" name="confirmPassword" autoComplete="new-password" style={{ color: '#404042', fontWeight: 500 }}
                                className="loginCredItem input_data mandatoryFieldSpecial typePassword pt-4 pb-3" placeholder={this.props.locales.SettingsCompReTypePswPlc}
                                onChange={(event) => this.inputValueChange("confirmPassword", event.target.value)}
                                onKeyUp={(event) => this.displayLabel(event, this.state.confirmPassword, this.props.locales.SettingsCompReTypePswPlc)} />
                            <div className="errorDesc" style={{ color: 'red', fontSize: 12, fontWeight: 400 }}></div>
                            <div className="errorDescription" style={{ color: 'red', fontSize: 12, fontWeight: 400 }}></div>
                        </div>
                        <div className="form-group col-md-12 pt-2" style={{fontSize:12}}>
                            {this.props.locales.SettingsCompCharecterToolTip}
                        </div>
                        <div className="col-md-11">
                            <Button className="loginPageLoginButton mb-2" onClick={() => { this.submitBtnClicked() }}>
                                {this.props.locales.registerCredentialNextBtn}&nbsp; <FaArrowRight />
                            </Button>
                        </div>
                    </div>
                    <div className="col-md-1"></div>
                </div>
            </div>
        )
    }

    loginPartComponent() {
        return (
            <div className=" col-md-12 row m-0 d-flex flex-column" style={{ height: '100%' }}>
                <div className="col-md-12 row pt-5 m-0" style={{ flex: 1 }}>
                    <div className="col-md-1"></div>
                    <div className="col-md-6 pl-5 ml-3"><img alt="" src={ApuaWhiteTextLogo} /></div>
                    <div className="col-md-5"></div>
                </div>
                <div className="col-md-12 row p-0 m-0 " style={{ flex: 4, alignItems: 'center' }}>
                    <div className="col-md-1"></div>
                    <div className="loginPageLeftPart col-md-9" >
                        <div className="col-md-12  pl-5" style={{ marginTop: '-70px' }}>
                            <div className="mb-1 col-md-12" style={{ fontSize: 32, color: '#ffffff', fontWeight: 300 }}>{this.props.locales.registerFirstStepAlreadyHvAccountTxt}</div>
                            <div className="mb-5 pb-4 col-md-12" style={{ fontSize: 16, color: '#ffffff', fontWeight: 300 }}>{this.props.locales.registerFirstStepSignInHereTxt}</div>
                            <div className="col-md-12 " style={{ marginTop: 50 }}>
                                <Button className="loginPageRegisterButton" style={{ fontSize: 24, fontWeight: 500 }} onClick={() => { this.loginButtonClicked() }}>
                                    {this.props.locales.registerFirstStepSignInBtn}
                                </Button>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-2"></div>
                </div>
            </div>
        )
    }

    loginButtonClicked() {
        window.location.reload();
    }

    displayLabel(event, value, placeHolderText) {
        if (value != "") {
            event.target.previousSibling.classList.remove('d-none');
            event.target.placeholder = "";
        } else {
            event.target.previousSibling.classList.add('d-none');
            event.target.placeholder = placeHolderText;
        }
    }

}
const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales,
        userRegisterDetails: state.userRegisterDetails
    }
}
function mapDispatchToProps(dispatch) {
    return {
        setLoginPage: function (key, payload) {
            dispatch(setLoginPage(key, payload));
        },
        setUserRegisterDetails: function (key, payload) {
            dispatch(setUserRegisterDetails(key, payload))
        }
    }
}

const RegisterCredentialsComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(RegisterCredentialsComponent)


export default RegisterCredentialsComponentContainer;
